export default {
    url: 'delta-3-max-series-preheat',
    include: ['jp'],
};
